export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade encryption and security protocols to protect your data and privacy across all our applications.',
      gradient: 'from-orange-400 to-orange-600',
      height: 'h-80'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Performance Optimization',
      description: 'Optimized code and efficient algorithms ensure smooth performance without draining your battery.',
      gradient: 'from-teal-400 to-teal-600',
      height: 'h-72'
    },
    {
      icon: 'ri-layout-line',
      title: 'Intuitive Interface',
      description: 'Beautiful, user-friendly designs that make complex features accessible to everyone.',
      gradient: 'from-purple-400 to-purple-600',
      height: 'h-64'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Synchronization',
      description: 'Seamlessly sync your settings and preferences across all your Apple devices.',
      gradient: 'from-blue-400 to-blue-600',
      height: 'h-72'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Battery Management',
      description: 'Smart power management features that extend your device battery life significantly.',
      gradient: 'from-green-400 to-green-600',
      height: 'h-80'
    },
    {
      icon: 'ri-lock-line',
      title: 'Privacy Controls',
      description: 'Comprehensive privacy settings give you complete control over your personal information.',
      gradient: 'from-pink-400 to-pink-600',
      height: 'h-64'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features delivered through regular app updates.',
      gradient: 'from-indigo-400 to-indigo-600',
      height: 'h-72'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Coverage',
      description: 'Access our services from anywhere in the world with reliable global infrastructure.',
      gradient: 'from-cyan-400 to-cyan-600',
      height: 'h-80'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-50 py-24 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <div className="inline-block px-6 py-2 bg-orange-500 rounded-full mb-6">
            <span className="text-xs uppercase tracking-widest text-white">MEET THE EXPERTS</span>
          </div>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">
            Powerful Features
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover the comprehensive features that make our applications stand out in the iOS ecosystem
          </p>
        </div>

        {/* Features Grid - Masonry Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${feature.height} flex flex-col cursor-pointer`}
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center mb-6 shadow-md`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>

              {/* Decorative corner element */}
              <div className="mt-4 flex justify-end">
                <div className="w-8 h-8 border-2 border-gray-200 rounded-lg rotate-45"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info Section */}
        <div className="mt-20 bg-gradient-to-r from-slate-900 to-slate-800 rounded-3xl p-12 text-center">
          <h3 className="text-4xl font-bold text-white mb-4">
            Built for the Modern iOS User
          </h3>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Every feature is carefully crafted to provide the best possible experience on iOS devices. We continuously innovate to stay ahead of user needs and technological advancements.
          </p>
        </div>
      </div>
    </div>
  );
}